const ADMIN_PARTS_LIBRARY = 'fulcrum/container/Admin/PartsLibrary/ADMIN_PARTS_LIBRARY'
const UPDATE_EDIT_VALUE = 'fulcrum/container/Admin/PartsLibrary/UPDATE_EDIT_VALUE'
const UPDATE_PARTS = 'fulcrum/container/Admin/PartsLibrary/UPDATE_PARTS'
const UPDATE_PART_DATA = 'fulcrum/container/Admin/PartsLibrary/UPDATE_PART_DATA'
const UPDATE_LAST_UPDATED = 'fulcrum/container/Admin/PartsLibrary/UPDATE_LAST_UPDATED'
const UPDATE_LOADING_PART = 'fulcrum/container/Admin/PartsLibrary/UPDATE_LOADING_PART'

const FETCH_PARTS = 'fulcrum/container/Admin/PartsLibrary/FETCH_PARTS'
const FETCH_PARTS_START = 'fulcrum/container/Admin/PartsLibrary/FETCH_PARTS_START'
const FETCH_PARTS_SUCCESS = 'fulcrum/container/Admin/PartsLibrary/FETCH_PARTS_SUCCESS'
const FETCH_PARTS_ERROR = 'fulcrum/container/Admin/PartsLibrary/FETCH_PARTS_ERROR'

const POST_PARTS = 'fulcrum/container/Admin/PartsLibrary/POST_PARTS'
const POST_PARTS_START = 'fulcrum/container/Admin/PartsLibrary/POST_PARTS_START'
const POST_PARTS_SUCCESS = 'fulcrum/container/Admin/PartsLibrary/POST_PARTS_SUCCESS'
const POST_PARTS_ERROR = 'fulcrum/container/Admin/PartsLibrary/POST_PARTS_ERROR'

const DIALOG_TYPE = Object.freeze({
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
})

const INFINITE = 10000

const FORMATTING_RANGES = Object.freeze({
  cpuList: {
    titleRanges: [
      {
      'rowStart': 0,
      'rowEnd': 0,
      'colStart': 0,
      'colEnd': INFINITE
      }
    ],
    horizontalSubtitleRanges: [
      {
        'rowStart': 1,
        'rowEnd': 1,
        'colStart': 0,
        'colEnd': INFINITE
      }
    ],
    verticalSubtitleRanges: [],
    checkboxRanges: [
      {
        'rowStart': 2,
        'rowEnd': 1000,
        'colStart': 4,
        'colEnd': 5
      }
    ],
    mergeRanges: [
      {
        'row': 0,
        'col': 0,
        'rowspan': 1,
        'colspan': 4
      }, {
        'row': 0,
        'col': 4,
        'rowspan': 1,
        'colspan': 2
      }
    ],
    dropdownCells: []
  },
  default: {
    titleRanges: [],
    horizontalSubtitleRanges: [
      {
        'rowStart': 0,
        'rowEnd': 0,
        'colStart': 0,
        'colEnd': INFINITE
      }
    ],
    verticalSubtitleRanges: [],
    checkboxRanges: [],
    mergeRanges: [],
    dropdownCells: []
  }
})

export {
  DIALOG_TYPE,
  ADMIN_PARTS_LIBRARY,
  UPDATE_EDIT_VALUE,
  UPDATE_LAST_UPDATED,
  UPDATE_LOADING_PART,
  UPDATE_PARTS,
  UPDATE_PART_DATA,
  FETCH_PARTS,
  FETCH_PARTS_START,
  FETCH_PARTS_SUCCESS,
  FETCH_PARTS_ERROR,
  POST_PARTS,
  POST_PARTS_START,
  POST_PARTS_SUCCESS,
  POST_PARTS_ERROR,
  FORMATTING_RANGES
}
